var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "role"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('b', [_vm._v("Add/Edit Cargo Damage")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.Backinvestigation
    }
  }, [_vm._v("Back")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [_c('form', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "MPS Number : <span style='color: red'>*</span>  :",
      "description": ""
    }
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-book'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.awbnumber),
      expression: "awbnumber"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "awbnumber",
      "name": "awbnumber",
      "type": "text"
    },
    domProps: {
      "value": (_vm.awbnumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.awbnumber = $event.target.value
      }
    }
  }), _vm._v(" "), _c('b-input-group-button', {
    slot: "right"
  }, [_c('b-button', {
    staticClass: "btn btn-secondary",
    on: {
      "click": function($event) {
        _vm.getData()
      }
    }
  }, [_vm._v("Go "), _c('i', {
    staticClass: "fa fa-arrow-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', [_vm._v(" Current Region:")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-marker'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "origin_hub_name",
      "name": "origin_hub_name",
      "disabled": ""
    },
    model: {
      value: (_vm.alldata.ZoneName),
      callback: function($$v) {
        _vm.alldata.ZoneName = $$v
      },
      expression: "alldata.ZoneName"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', [_vm._v("Origin Hub/SVC :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-marker'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "current_hub_name",
      "name": "current_region_name",
      "disabled": ""
    },
    model: {
      value: (_vm.alldata.originHubName),
      callback: function($$v) {
        _vm.alldata.originHubName = $$v
      },
      expression: "alldata.originHubName"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', [_vm._v(" Current Hub/SVC:")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-marker'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "current_hub_name",
      "name": "current_region_name",
      "disabled": ""
    },
    model: {
      value: (_vm.alldata.currentHubName),
      callback: function($$v) {
        _vm.alldata.currentHubName = $$v
      },
      expression: "alldata.currentHubName"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Damage Type <span style='color: red'>*</span>  :",
      "label-cols": 4,
      "horizontal": true
    }
  }, [_c('div', {
    key: _vm.index,
    on: {
      "change": function($event) {
        _vm.selectData()
      }
    }
  }, [_c('div', {
    staticClass: "Radio-btns"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.damageType),
      expression: "damageType"
    }],
    attrs: {
      "type": "radio",
      "name": "Major",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.damageType, "2")
    },
    on: {
      "__c": function($event) {
        _vm.damageType = "2"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Major")])])])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Damage Zone :"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-university'></i>"
    }
  }, [_c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticStyle: {
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "name": "Damagezone",
      "id": "Damagezone",
      "label": "label",
      "options": _vm.HubZoneData,
      "placeholder": "Enter Zone"
    },
    on: {
      "input": function($event) {
        _vm.callHub(_vm.Damagezone)
      }
    },
    model: {
      value: (_vm.Damagezone),
      callback: function($$v) {
        _vm.Damagezone = $$v
      },
      expression: "Damagezone"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Damagezone')),
      expression: "errors.has('Damagezone')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Module Url field is required.\n                  ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Damage Hub/SVC:"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-university'></i>"
    }
  }, [_c('Multiselect', {
    staticStyle: {
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "name": "HubName",
      "label": "label",
      "options": _vm.hubdata,
      "placeholder": "Enter Zone"
    },
    model: {
      value: (_vm.HubName),
      callback: function($$v) {
        _vm.HubName = $$v
      },
      expression: "HubName"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('newhubs')),
      expression: "errors.has('newhubs')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('newhubs')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6 "
  }, [_c('label', [_vm._v("Reason: "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-university'></i> "
    }
  }, [_c('Multiselect', {
    staticStyle: {
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "name": "Reason",
      "label": "label",
      "options": _vm.ReasonList,
      "placeholder": "Enter Reason"
    },
    model: {
      value: (_vm.Reason),
      callback: function($$v) {
        _vm.Reason = $$v
      },
      expression: "Reason"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('newhubs')),
      expression: "errors.has('newhubs')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('newhubs')))])], 1)]), _vm._v(" "), (_vm.showCategory) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Damage Category:")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-university'></i>"
    }
  }, [_c('Multiselect', {
    staticStyle: {
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "name": "DamageCategory:",
      "label": "label",
      "options": _vm.DamageCategorylist,
      "placeholder": "Enter Reason"
    },
    model: {
      value: (_vm.DamageCategory),
      callback: function($$v) {
        _vm.DamageCategory = $$v
      },
      expression: "DamageCategory"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('newhubs')),
      expression: "errors.has('newhubs')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('newhubs')))])], 1)]) : _vm._e(), _vm._v(" "), (_vm.showupload) ? _c('div', {
    staticClass: "form-group-row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Upload 5 Images :<span style='color: red'>*</span> ",
      "description": "Allowed image file types: gif, jpg, jpeg, png (Maximum Size :600 KB)",
      "label-cols": 3
    }
  }), _vm._v(" "), _c('b-input-group', [_c('input', {
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imageGroup"
  }, _vm._l((_vm.images), function(image, index) {
    return _c('div', {
      staticClass: "image-view-upload row"
    }, [_c('img', {
      staticClass: "col-md-offset-20 col-md-2 col-sm-10 col-xs-4",
      attrs: {
        "src": image.url
      },
      on: {
        "click": function($event) {
          _vm.showImage(image.url)
        }
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          _vm.deleteImage(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      staticStyle: {
        "font-size": "25px"
      }
    })])])
  }))], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Description :"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "description",
      "name": "description",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "disabled": _vm.submitDisable,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.InsertData()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-save"
  }), _vm._v(" Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        _vm.resetForm()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v("\n                Reset")])])])])])], 1)]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "active": _vm.show,
      "duration": "0.6",
      "spinner": "bar-fade-scale",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "imgPopUp",
      "title": "BootstrapVue"
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('b-card', [_c('span', {
    staticClass: "download-btn"
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.img,
      "download": ""
    }
  }, [_vm._v("Download")])]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.img,
      "alt": "loading..."
    }
  })])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37e86372","hasScoped":true}!./src/views/components/B2B/OperatonExcutve/AddCargoShipment/AddCargoShipment.component.html
// module id = 562
// module chunks = 1